module.exports = "/_next/static/images/instagram-filled-icon-c3ee3bc3ccef242b1b114b2bc805d62a.svg";